var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTailored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 252,
    height: 152,
    viewBox: "0 0 252 152",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "tailored-1",
    d: "M191.748 2.34794L176.324 76.1798L218.852 13.8871L176.348 76.1967L239.478 34.9204L176.364 76.2212L250.484 62.2455L176.37 76.2504L250.196 91.7029L176.364 76.279L238.657 118.808L176.347 76.3035L217.623 139.433L176.323 76.3195L190.298 150.439L176.293 76.3252L160.841 150.151L176.265 76.3192L133.736 138.612L176.24 76.3023L113.111 117.578L176.224 76.2778L102.104 90.2535L176.219 76.2486L102.393 60.7961L176.225 76.22L113.932 33.6914L176.241 76.1955L134.965 13.066L176.266 76.1795L162.29 2.05954L176.295 76.1738L191.748 2.34794Z",
    stroke: "#CDD0D6",
    strokeWidth: 8.52422
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "tailored-2",
    d: "M176.294 0.750989C156.27 0.750989 137.067 8.70543 122.908 22.8644C108.749 37.0234 100.794 56.2271 100.794 76.251C100.794 96.2748 108.749 115.479 122.908 129.638C137.067 143.797 156.27 151.751 176.294 151.751L176.294 76.251L176.294 0.750989Z",
    fill: "#B4B7BC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "tailored-3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.754 2.42871C97.6365 5.45637 84.5649 12.4972 74.1979 22.8642C60.0389 37.0232 52.0845 56.2269 52.0845 76.2507C52.0845 96.2746 60.0389 115.478 74.1979 129.637C84.5649 140.004 97.6364 147.045 111.754 150.073V2.42871ZM127.3 151.75C127.395 151.751 127.49 151.751 127.584 151.751V151.75H127.3Z",
    fill: "#56585B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "tailored-4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.7782 7.70996C36.7751 11.4067 29.4061 16.5108 23.0528 22.8641C8.89377 37.0231 0.939331 56.2268 0.939331 76.2506C0.939329 96.2745 8.89377 115.478 23.0528 129.637C29.4061 135.991 36.7751 141.095 44.7782 144.791V7.70996ZM76.1551 151.75C76.2498 151.75 76.3446 151.751 76.4393 151.751V151.75H76.1551Z",
    fill: "#282A2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailored);
export default __webpack_public_path__ + "static/media/tailored.3b83dcb7afe2116ccc78a5b57e719827.svg";
export { ForwardRef as ReactComponent };